// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","389":"4c942803","732":"fda73a07","814":"b6dba2af","857":"b3c10298","977":"01378288"}[chunkId] + ".chunk.js";
};